import {performHttpRequest} from "@/http/http";

export async function postGeoAhn3D(data) {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/geo/ahn/3d',
        'POST',
        data,
        'text/html',
        false
    )
}

export async function postGeoAhn(data) {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/geo/ahn',
        'POST',
        data,
        'text/html',
        false
    )
}
